import { HttpUrlEncodingCodec } from '@angular/common/http';

/**
 * Angular's default HttpUrlEncodingCodec calls encodeURIComponent() and then deliberately
 * un-encodes several RFC 3986 sub-delimiters it considers "safe" in a query string - including
 * turning `%3B` back into a literal `;` and `%2B` back into a literal `+`. That's spec-compliant,
 * but the SmartPass backend (Go's net/url.ParseQuery) silently drops any query param whose value
 * contains an un-encoded `;`, and treats a literal `+` as an encoded space. There is no
 * server-side fix for this (a fix was built and reviewed but never merged), so this codec - and
 * its global registration via HttpParamEncodingInterceptor - is the only protection against it.
 */
export class SemicolonSafeUrlEncodingCodec extends HttpUrlEncodingCodec {
	override encodeKey(key: string): string {
		return this.keepEncoded(super.encodeKey(key));
	}

	override encodeValue(value: string): string {
		return this.keepEncoded(super.encodeValue(value));
	}

	private keepEncoded(encoded: string): string {
		return encoded.replace(/;/g, '%3B').replace(/\+/g, '%2B');
	}
}
